// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"95200c17","234":"5578726f","387":"e309812b","388":"54d0703d","787":"37361e0b","860":"912d554f"}[chunkId] + ".chunk.js";
};